import { isCancelled, withoutCancelled } from './cancelled-workshops';
import type { WeekStartsOn } from './workshops-calendar-dates';
import { inDisplayedPeriod } from './workshops-calendar-period';
import type { CalendarView, WorkshopChip } from './workshopsCalendarTypes';

export interface CalendarVisibilityInput {
  workshops: WorkshopChip[];
  view: CalendarView;
  anchor: Date;
  weekStartsOn: WeekStartsOn;
  now: Date;
}

export interface CalendarVisibility {
  /** The workshops less cancelled ones, unless the viewer asked to see them. */
  shown: WorkshopChip[];
  /** `shown`, inside the displayed month, week or list window. */
  inPeriod: WorkshopChip[];
  /** Cancelled workshops the toggle would reveal in the displayed period. */
  cancelledInPeriod: number;
}

export function calendarVisibility(
  input: CalendarVisibilityInput & { showCancelled: boolean },
): CalendarVisibility {
  const { workshops, showCancelled, view, anchor, weekStartsOn, now } = input;
  const inPeriodOf = (w: WorkshopChip) => inDisplayedPeriod(w, view, anchor, weekStartsOn, now);

  const shown = showCancelled ? workshops : withoutCancelled(workshops);
  return {
    shown,
    inPeriod: shown.filter(inPeriodOf),
    cancelledInPeriod: workshops.filter((w) => isCancelled(w) && inPeriodOf(w)).length,
  };
}
